const VALIDATION_ERRORS_QUERY = `
  details
  field
  memberIdentifier
  path
`;

export default VALIDATION_ERRORS_QUERY;
